/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P2_Pro_Title_2Inputs */

const en_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow Your Own Unique Forest with Plus`)
};

const ar_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ غابتك الفريدة مع بلس`)
};

const de_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Züchten Sie mit Plus Ihren eigenen, einzigartigen Wald`)
};

const es_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultiva tu propio bosque único con Plus`)
};

const fr_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultivez votre propre forêt unique avec Plus`)
};

const it_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai crescere la tua foresta unica con Plus`)
};

const ja_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus で自分だけの森を育てよう`)
};

const ko_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus로 나만의 숲을 키워보세요`)
};

const pt_br_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultive sua própria floresta exclusiva com o Plus`)
};

const ru_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вырастите свой уникальный лес с Plus`)
};

const th_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างป่าแห่งสมาธิที่เป็นเอกลักษณ์ของคุณด้วย Plus`)
};

const tr_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus ile kendi eşsiz ormanınızı yetiştirin`)
};

const zh_cn_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Plus，打造你独一无二的专属森林`)
};

const zh_tw_subscription_walkthrough_p2_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P2_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Plus，打造你獨一無二的專屬森林`)
};

/**
* | output |
* | --- |
* | "Grow Your Own Unique Forest with Plus" |
*
* @param {Subscription_Walkthrough_P2_Pro_Title_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p2_pro_title_2 = /** @type {((inputs?: Subscription_Walkthrough_P2_Pro_Title_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P2_Pro_Title_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "de") return de_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "es") return es_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "it") return it_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "th") return th_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p2_pro_title_2(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p2_pro_title_2(inputs)
	return zh_tw_subscription_walkthrough_p2_pro_title_2(inputs)
});